import React from 'react';
import { ExternalOidcRegisterUserAgreement } from 'pages/Register/components/RegisterUserAgreement/ExternalOidcRegisterUserAgreement';
import { AuthPageLayout } from 'components/layout';
import { useParams } from 'react-router-dom';

type RouteParams = { token: string };

export const ExternalOidcRegistration: React.FC = () => {
  const { token } = useParams<RouteParams>();

  return (
    <>
      <AuthPageLayout>
        <ExternalOidcRegisterUserAgreement token={token} />
        <AuthPageLayout.Footer />
      </AuthPageLayout>
    </>
  );
};
